import UserAgreement from "../component/UserAgreement/UserAgreement";

function SupportPage(props) {
  return (
    <div>
      <UserAgreement />
    </div>
  );
}

export default UserAgreement;
